import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Loan_API } from "../../Helper";

import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  FaCalculator,
  FaFileInvoiceDollar,
  FaLockOpen,
  FaStar,
  FaRocket,
  FaExclamationTriangle,
  FaExchangeAlt,
  FaUniversity,
  FaGlobe,
  FaGraduationCap,
  FaBook,
  FaTools,
  FaBriefcase,
  FaLock,
  FaMoneyBillWave,
  FaGlobeAsia,
  FaUserClock,
  FaUserFriends,
  FaCreditCard,
  FaBookOpen,
  FaClock,
} from "react-icons/fa";
import {
  FaRupeeSign,
  FaPercentage,
  FaPauseCircle,
  FaUserShield,
  FaListUl,
} from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const EducationLoanNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
      question: "  What is an education loan?",
      answer:
        "An education loan is a financial arrangement in which a lender provides funds to help you pay for college or other educational expenses. This loan can cover tuition, books, supplies, and even living costs. You agree to repay the loan over a specified period, typically with interest, after you graduate or complete your studies.",
    },
    {
      question:
        "What factors should I consider when choosing an education loan?",
      answer:
        "When selecting an education loan, consider factors like the interest rate, loan term, repayment options, and total loan cost. It is also important to evaluate your financial need and whether the loan is subsidized or unsubsidized. Additionally, assess the deferment and forbearance options, as well as any available loan forgiveness programs.",
    },
    {
      question:
        " Which bank offers the lowest interest rate on education loans?",
      answer:
        "The interest rate for education loans depends on several factors, including the loan amount, your credit history, type of loan (subsidized or unsubsidized), and loan tenure. To find the best rate, compare offers from different banks and lending institutions. Personalized rates can be obtained by providing your financial information to lenders and using our comparison tools to assess your best options.",
    },
    {
      question: "Can I get an education loan through TheFinMaster.com?",
      answer:
        " TheFinMaster.com does not offer education loans directly. However, we provide educational resources, loan comparison tools, and unbiased information to help you understand education loans and choose the best one for your needs. Once you have identified a suitable loan, you will be directed to the lenders website to complete a secure application process.",
    },
    {
      question:
        "What is the maximum amount I can borrow with an education loan?",
      answer:
        "The loan amount depends on the institution and course you’re pursuing. Typically, loans can range from ₹10 lakhs for studies in India and up to ₹20–30 lakhs for studies abroad. Some banks may offer higher amounts for prestigious or expensive institutions.",
    },
    {
      question: "What is the interest rate on education loans?",
      answer:
        "Interest rates for education loans typically range from 8% to 15%, depending on the loan amount, tenure, and type of course. Government-backed loans often have lower rates, and rates may also vary for loans taken for domestic vs. international education.",
    },
    {
      question: "Are there any collateral requirements for an education loan?",
      answer:
        "Collateral is generally not required for loans up to ₹7.5 lakhs. For amounts above this threshold, banks may require collateral such as property or fixed deposits, particularly for loans taken to study abroad.",
    },
    {
      question: "Can I apply for an education loan for my child's education?",
      answer:
        "Yes, parents or guardians can apply for an education loan on behalf of their children. The loan will typically be in the parent or guardian’s name, but the funds will be used for the student's education.",
    },
    {
      question: "Is there an age limit to apply for an education loan?",
      answer:
        "The age limit for education loans varies from lender to lender. Generally, you must be between 18 to 35 years old at the time of application. The limit may be higher for students pursuing postgraduate courses or those with a strong academic background.",
    },
    {
      question: "What documents do I need to apply for an education loan?",
      answer:
        "Common documents include proof of identity (Aadhar, PAN), proof of admission to an educational institution, academic transcripts, proof of income (IT returns or salary slips for parents), and bank statements for the last 6 months.",
    },
    {
      question: "Can I get an education loan for online courses?",
      answer:
        "Yes, many banks offer education loans for online courses, especially if they are recognized by universities or accredited organizations. However, the course and institution must meet the lender’s eligibility criteria for the loan.",
    },
    {
      question: "Is there any processing fee for education loans?",
      answer:
        "Yes, banks may charge a processing fee for education loans, typically ranging from ₹500 to ₹10,000. Some banks may offer fee waivers during specific promotional periods, so it’s advisable to check with the lender before applying.",
    },
    {
      question: "Can I apply for an education loan without a guarantor?",
      answer:
        "For loans up to ₹4 lakhs, most banks do not require a guarantor. For higher amounts, a co-applicant (usually a parent or guardian) or a guarantor is often required to secure the loan. The guarantor must have a good credit score and financial standing.",
    },
    {
      question: "What is the tenure of an education loan?",
      answer:
        "The tenure for education loans typically ranges from 5 to 15 years, depending on the loan amount and repayment ability. Post the moratorium period (course duration + 6 months), the repayment starts, and you can choose a tenure that suits your financial capacity.",
    },
    {
      question: "Can I get an education loan for studying abroad?",
      answer:
        "Yes, many banks offer education loans for studying abroad. The loan can cover tuition fees, living expenses, and other associated costs. The eligibility criteria and loan amount may vary, so it's important to check with the bank for specific terms.",
    },
    {
      question: "What is the moratorium period for education loans?",
      answer:
        "The moratorium period refers to the time when you are not required to make loan repayments. It typically lasts for the duration of the course plus 6 months to 1 year after completion. During this period, interest may either accrue or be waived, depending on the lender.",
    },
    {
      question: "What happens if I am unable to repay my education loan?",
      answer:
        "If you are unable to repay your education loan, you may be charged penalties, and your credit score will be negatively affected. In extreme cases, the bank may take legal action to recover the amount. It's essential to inform the bank if you're facing difficulties to explore options like restructuring or a repayment extension.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchLoanData();
  }, []);
  const fetchLoanData = async () => {
    try {
      const response = await Http.get(Loan_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.loan || response;

      // Filter the insurance data to show only Car category
      const carLoanData = Array.isArray(data)
        ? data.filter(
            (insurance) => insurance.category_name === "Education Loan"
          )
        : [];

      setLoanData(carLoanData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Loan data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const loanTypes = [
    {
      name: "Skill Development Loan 🛠️",
      description:
        "Introduced to promote vocational training and short-term skill development courses, this loan is provided for government-recognized programs to help students enhance their employability.",
      icon: <FaTools />,
    },
    {
      name: "Undergraduate Education Loan 🏫",
      description:
        "These loans are specifically designed for students enrolling in undergraduate courses. The repayment typically starts after the completion of the course with a moratorium period.",
      icon: <FaGraduationCap />,
    },
    {
      name: " Postgraduate Education Loan 🎓",
      description:
        "Students pursuing postgraduate degrees, including MBA, MS, and other professional courses, can avail of this loan. Many banks offer higher loan amounts for reputed institutions.",
      icon: <FaBook />,
    },
    {
      name: "Domestic Education Loan 🎓",
      description:
        "This type of loan is for students pursuing higher education in India. Banks and NBFCs provide loans to cover tuition fees, hostel fees, books, and other expenses. The loan amount varies based on the course and institution.",
      icon: <FaUniversity />,
    },

    {
      name: "Loan Against Collateral (Secured Education Loan) 🏦",
      description:
        "These loans require the borrower to pledge collateral such as property, fixed deposits, or insurance policies. They typically come with lower interest rates and higher loan amounts.",
      icon: <FaLock />,
    },
    {
      name: " Loan for Executive Education 👔",
      description:
        "Designed for working professionals who want to pursue executive education programs, such as Executive MBA or other advanced management programs.",
      icon: <FaBriefcase />,
    },
    {
      name: " Loan Without Collateral (Unsecured Education Loan) 💰",
      description:
        "For students studying at top-ranked institutions, banks and NBFCs provide unsecured loans based on the student's academic merit and parental income, but they usually have higher interest rates.",
      icon: <FaMoneyBillWave />,
    },
    {
      name: " Overseas Education Loan ✈️",
      description:
        "Students who wish to study abroad can avail of this loan to cover tuition fees, travel expenses, accommodation, and other related costs. Lenders consider factors like university ranking, country, and student's academic background before approving the loan.",
      icon: <FaGlobe />,
    },
  ];

  const points = [
    {
      title: " Lower Interest Rates",
      description: ` Compared to personal loans, education loans have lower interest rates, making repayment easier.`,
    },
    {
      title: "Flexible Repayment",
      description: ` Most banks offer a moratorium period (course duration + 6-12 months) before repayment begins.`,
    },
    {
      title: "Higher Loan Amounts",
      description: ` Covers tuition fees, living expenses, books, travel, and other educational costs.`,
    },
    {
      title: "Tax Benefits",
      description: ` Interest paid on education loans is tax-deductible under Section 80E of the Income Tax Act.`,
    },
    {
      title: "Encourages Financial Independence ",
      description: ` Helps students finance their education without burdening their family.`,
    },
  ];
  const points1 = [
    {
      title: "  Collateral for Higher Amounts",
      description: `Loans above ₹7.5 lakh may require security (property, fixed deposits, etc.).`,
    },
    {
      title: " Eligibility Criteria  ",
      description: ` Requires a good academic record and admission into recognized institutions.`,
    },
    {
      title: "Co-Applicant Liability",
      description: `A parent/guardian must co-sign, making them responsible if the borrower defaults.`,
    },
    {
      title: "Impact on Credit Score ",
      description: ` If repayments are delayed after the moratorium period, it can negatively impact credit score.`,
    },
    {
      title: "Limited to Educational Expenses",
      description: ` Unlike personal loans, which can be used for any purpose, education loans can only be used for academic-related expenses.`,
    },
  ];

  const points3 = [
    {
      title: " Loan Amount & Coverage",
      points: [
        " Before selecting a loan, check whether it covers tuition fees, accommodation, books, travel expenses, and other academic costs. Some lenders provide 100% financing, while others require a margin (such as 5-15% contribution from the borrower).",
      ],
    },
    {
      title: " Interest Rate & Type",
      points: [
        "Compare interest rates from different banks and NBFCs. Education loans typically have interest rates ranging from 8-12%, but it varies based on the lender and borrower profile. Also, check whether the loan offers:",
        "Fixed Interest Rate (constant throughout the loan tenure).",
        "Floating Interest Rate (varies based on market conditions)",
      ],
    },
    {
      title: " Repayment Flexibility & Moratorium Period",
      points: [
        "A good education loan should offer a moratorium period (course duration + 6-12 months after completion). This allows students to secure a job before starting repayment. Longer loan tenures (up to 15 years) reduce EMI burden.",
      ],
    },
    {
      title: "Collateral & Co-Applicant Requirement",
      points: [
        "Loans above ₹7.5 lakh usually require collateral (property, fixed deposits, etc.).",
        "A co-applicant (parent/spouse/guardian) is mandatory for most loans. Ensure that your co-applicant has a stable financial profile to avoid approval issues.",
      ],
    },
    {
      title: "Processing Fees & Hidden Charges",
      points: [
        "Some lenders charge processing fees, prepayment penalties, and late payment fees. Check for hidden costs and compare different lenders to minimize extra charges.",
      ],
    },
    {
      title: " Loan Disbursement Process",
      points: [
        "For international studies, ensure that the loan disburses funds directly to the university in the required currency and within deadlines. Delays in disbursement can affect admission confirmations and visa approvals.",
      ],
    },
    {
      title: " Government Subsidies & Tax Benefits",
      points: [
        "Students from economically weaker sections may be eligible for interest subsidies under government schemes.",
        "Interest paid on an education loan qualifies for tax deductions under Section 80E of the Income Tax Act.",
      ],
    },
    {
      title: " Loan Provider's Credibility & Customer Support",
      points: [
        "Choose a reliable bank/NBFC with a good service record, flexible policies, and easy online access for loan management.",
      ],
    },
  ];

  const eligibilityCriteria = [
    {
      title: "Nationality",
      points: [
        "The applicant must be an Indian citizen.",
        "Non-Resident Indians (NRIs), Overseas Citizens of India (OCIs), and Persons of Indian Origin (PIOs) may also be eligible for specific loan schemes.",
      ],
      icon: <FaGlobeAsia className="text-blue-500 text-2xl" />,
    },
    {
      title: "Age Criteria",
      points: [
        "The applicant must typically be between 16 to 35 years at the time of applying for the loan.",
        "Some banks may have a maximum age limit of up to 45 years for working professionals opting for executive education loans.",
      ],
      icon: <FaUserClock className="text-green-500 text-2xl" />,
    },
    {
      title: "Academic Eligibility",
      points: [
        "The applicant must have secured admission to a recognized university or institution in India or abroad.",
        "Admission must be obtained through merit-based selection or entrance exams for undergraduate, postgraduate, or diploma courses.",
      ],
      icon: <FaGraduationCap className="text-blue-500 text-2xl" />,
    },

    {
      title: "Co-Applicant Requirement",
      points: [
        "A parent, guardian, spouse, or sibling is required as a co-applicant or guarantor for the loan.",
        "The co-applicant must have a stable income source to support loan repayment if required.",
      ],
      icon: <FaUserFriends className="text-red-500 text-2xl" />,
    },
    {
      title: "Credit Score and Financial Stability",
      points: [
        "A good credit history of the co-applicant (preferably 700 and above) improves loan approval chances.",
        "For unsecured loans, banks assess the financial stability and repayment capacity of the co-applicant.",
      ],
      icon: <FaCreditCard className="text-purple-500 text-2xl" />,
    },

    {
      title: "Collateral Requirement",
      points: [
        "For loans exceeding ₹7.5 lakh, collateral such as property, fixed deposits, or life insurance policies may be required.",
        "Loans below ₹7.5 lakh are often provided without collateral, based on the applicant’s and co-applicant’s profile.",
      ],
      icon: <FaLock className="text-green-500 text-2xl" />,
    },
    {
      title: "Eligible Courses",
      points: [
        "Loans are provided for full-time, part-time, and vocational courses approved by UGC, AICTE, IIMs, IITs, government-recognized institutes, and reputed foreign universities.",
        "Professional and technical courses such as MBA, MBBS, MS, Engineering, Aviation, Hospitality, and Law are commonly financed.",
      ],
      icon: <FaBookOpen className="text-orange-500 text-2xl" />,
    },
  ];
  const componentsData1 = [
    {
      title: "Repayment Tenure",
      icon: <FaCalendarAlt className="text-2xl text-yellow-600" />,
      points: [
        "The tenure ranges from 5 to 15 years, depending on the bank and loan amount.",
        "A longer repayment period results in smaller EMIs but higher overall interest payments.",
      ],
    },
    {
      title: "Collateral Requirement",
      icon: <FaLock className="text-2xl text-red-600" />,
      points: [
        "Loans up to ₹7.5 lakh are often unsecured, requiring no collateral.",
        "For higher loan amounts, collateral like property, fixed deposits, or LIC policies may be required.",
      ],
    },
    {
      title: "Loan Amount",
      icon: <FaRupeeSign className="text-2xl text-green-600" />,
      points: [
        "The loan amount depends on the tuition fees, living expenses, travel costs (for studying abroad), and other educational expenses.",
        "Banks typically offer ₹4 lakh to ₹20 lakh for domestic studies and up to ₹1.5 crore for studying abroad.",
      ],
    },

    {
      title: "Co-Applicant Requirement",
      icon: <FaUserShield className="text-2xl text-indigo-600" />,
      points: [
        "A parent, guardian, or spouse is usually required as a co-applicant to ensure loan repayment if the student is unable to do so.",
        "The co-applicant's credit score and financial background play a crucial role in loan approval.",
      ],
    },
    {
      title: "Interest Rate",
      icon: <FaPercentage className="text-2xl text-blue-600" />,
      points: [
        "The interest rate varies based on the loan amount, collateral, and creditworthiness of the co-applicant.",
        "Rates generally range from 8% to 15% per annum, with lower rates for loans under government schemes.",
        "Some loans come with a floating or fixed interest rate.",
      ],
    },

    {
      title: "Moratorium Period (Repayment Holiday)",
      icon: <FaPauseCircle className="text-2xl text-purple-600" />,
      points: [
        "Most education loans provide a moratorium period, allowing students to start repaying 6 months to 1 year after course completion or securing a job.",
        "During this period, simple interest or EMI payments may be deferred, but interest may continue to accrue.",
      ],
    },

    {
      title: "Coverage of Expenses",
      icon: <FaListUl className="text-2xl text-pink-600" />,
      points: [
        "Tuition fees and admission charges",
        "Hostel and living expenses",
        "Travel costs (for international students)",
        "Books, laptops, and other study materials",
        "Examination and lab fees",
      ],
    },
    {
      title: "Subsidies & Government Schemes",
      icon: <FaUniversity className="text-2xl text-emerald-600" />,
      points: [
        "Certain government schemes, like the Central Sector Interest Subsidy (CSIS), provide interest-free loans during the moratorium period for students from economically weaker sections (EWS).",
        "Some banks offer lower interest rates for female students and students with merit-based admissions.",
      ],
    },
  ];
  const comparisonData2 = [
    {
      feature: "Purpose",
      icon: <FaBook className="w-4 h-4 inline-block text-blue-500 mr-1" />,
      educationLoan:
        "Specifically for educational expenses (tuition, books, living costs, etc.)",
      personalLoan: "Can be used for any purpose, including education",
    },
    {
      feature: "Interest Rate",
      icon: (
        <FaPercentage className="w-4 h-4 inline-block text-green-500 mr-1" />
      ),
      educationLoan: "Lower interest rates (typically 8-12%)",
      personalLoan: "Higher interest rates (10-24%)",
    },
    {
      feature: "Loan Amount",
      icon: (
        <FaMoneyBillWave className="w-4 h-4 inline-block text-purple-500 mr-1" />
      ),
      educationLoan:
        "Higher amounts offered, covering up to 100% of tuition fees",
      personalLoan: "Limited based on the borrower's creditworthiness",
    },
    {
      feature: "Repayment Start",
      icon: <FaClock className="w-4 h-4 inline-block text-yellow-500 mr-1" />,
      educationLoan:
        "Repayment starts after course completion + moratorium period",
      personalLoan: "Repayment starts immediately after loan disbursal",
    },
    {
      feature: "Collateral Requirement",
      icon: <FaLock className="w-4 h-4 inline-block text-pink-500 mr-1" />,
      educationLoan: "Required for higher loan amounts (above ₹7.5 lakh)",
      personalLoan:
        "Generally unsecured, but higher loan amounts may need collateral",
    },
    {
      feature: "Tax Benefits",
      icon: (
        <FaFileInvoiceDollar className="w-4 h-4 inline-block text-rose-500 mr-1" />
      ),
      educationLoan:
        "Interest payments qualify for tax deductions under Section 80E of the IT Act",
      personalLoan: "No tax benefits",
    },
    {
      feature: "Co-Applicant Requirement",
      icon: (
        <FaUserFriends className="w-4 h-4 inline-block text-indigo-500 mr-1" />
      ),
      educationLoan: "Mandatory co-applicant (parent/guardian/spouse)",
      personalLoan:
        "Not required unless borrower has low income or poor credit history",
    },
  ];
  const features = [
    { icon: "🎓", text: "  Fast EMI Estimates for Any Course" },
    { icon: "⏱️", text: "Takes Less Than a Minute" },
    { icon: "📊", text: "  Calculates Pre-EMI & Full EMI" },
    { icon: "📄", text: "No Student Details Needed" },
    { icon: "📲", text: " Smooth Experience on All Devices" },
    { icon: "💡", text: " Assists in Loan Planning for Studies" },
  ];
  return (
    <>
      <Helmet>
        <title>
        Education Loans in India – Fund Your Studies Easily
        </title>
        <meta
          name="description"
          content="Compare top education loan providers. Get low interest student loans with flexible repayment and fast approval."
        />
        <meta
          name="keywords"
          content="student education loan, private student loans, student loan application, education loan"
        />
        <link rel="canonical" href="https://thefinmaster.com/education-loan" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 ">Education Loan</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-4xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">
                    Invest in your future with easy Education Loans
                  </span>{" "}
                  fast approval, flexible repayment, and funding for every
                  academic journey
                </h1>
                {/* <a href="#insurance_plans">
                                           <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                                               See Plans
                                           </button>
                                       </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="/assets/el.png"
                alt="education-loan"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          TheFinMaster.com bridges the gap by simplifying your education loan
          search. Our platform connects you with a wide range of lenders
          offering education loans. Easily compare interest rates, repayment
          options, and eligibility criteria to find the perfect fit for
          financing your academic aspirations. TheFinMaster.com empowers you
          with knowledge to find the best education loan deal and unlock your
          full potential.
        </p>{" "}
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-3/4">
            <div id="loan_plans" className="lg:pr-6 md:px-4 px-2">
              {loading ? (
                <div className="text-center py-10">Loading Loan options...</div>
              ) : error ? (
                <div className="text-center py-10 text-red-600">{error}</div>
              ) : loanData.length === 0 ? (
                <div className="text-center py-10">
                  No Education Loan options available at the moment.
                </div>
              ) : (
                loanData.map((loan) => (
                  <div
                    key={loan.id}
                    className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
                  >
                    <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                      <Link to={`/education-loan/${loan.page_url}`}>
                        <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                          <img
                            className="w-full h-full object-contain"
                            alt={loan.page_title || "Loan Provider"}
                            src={loan.image}
                          />
                        </div>
                      </Link>
                    </div>

                    <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                      <p className="text-gray-500 font-medium">Interest Rate</p>
                      <h4 className="text-2xl py-0.5 font-bold">
                        {loan.interest_rate}%
                      </h4>
                    </div>

                    <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                      <p className="text-gray-500 font-medium">Loan Amount </p>
                      <h4 className="text-2xl py-0.5 font-bold">
                        ₹{loan.loan_amount}
                      </h4>
                    </div>

                    <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                      <p className="text-gray-500 font-medium">
                        Processing Fee
                      </p>
                      <h4 className="text-2xl py-0.5 font-bold">
                        ₹{loan.processing_fee}
                      </h4>
                    </div>

                    <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                      <a
                        href={loan.bank_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                          Apply Now
                        </button>
                      </a>

                      <Link to={`/education-loan/${loan.page_url}`}>
                        <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                          See Details
                        </button>
                      </Link>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
            <div className="sticky top-20">
              {/* Ad 1 - Visible on all screen sizes */}
              <AdBanner displayOrder="2" />
              {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
              {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}

              {/* Compact ad for mobile only */}
              {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl md:text-3xlfont-bold text-gray-800 mb-4">
            What is an Education Loan?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            An education loan is a type of financial assistance provided by
            banks and financial institutions to help students pursue higher
            education in India or abroad. It covers various expenses, including
            tuition fees, accommodation, books, travel, and other academic
            costs. These loans are typically offered at lower interest rates
            with flexible repayment options, often starting after course
            completion or a grace period post-employment.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            Education loans can be secured (requiring collateral) or unsecured
            (without collateral), depending on the loan amount and lender
            policies. They are beneficial for students who lack immediate funds
            but wish to invest in quality education for better career prospects.
            Many lenders also offer government-backed subsidies and
            interest-free moratorium periods for eligible students.
          </p>
        </div>
      </div>
      <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10">
          {/* Left - Text and CTA */}
          <div className="max-w-xl space-y-6 text-center md:text-left">
            <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
              Calculate Your Education Loan <br />
              in <span className="text-blue-600">Seconds</span>
            </h2>
            <p className="text-gray-700 text-lg">
              Use our fast and free calculator to estimate your premium — no
              paperwork, no waiting.
            </p>
            <Link
              to="/financial-tools-calculators/education-loan-emi-calculator"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
            >
              Start Calculating <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

          {/* Right - Feature List with Emojis */}
          <div className="space-y-4 text-left">
            {features.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <span className="text-xl">{item.icon}</span>
                <span className="text-gray-800 font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 py-6 text-center mt-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Key stats Education Loan
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🎓</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Low Penetration of Education Loans
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              Only about 4% of the total higher education student population in
              India benefits from education loans.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏦</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Interest Rates Offered by Major Banks
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              The State Bank of India (SBI) offers education loans with interest
              rates starting from 8.65% per annum, with variations based on loan
              specifics and borrower profiles.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📜</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Government Initiatives for Loan Accessibility
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              As of August 15, 2020, 37 banks were registered on the Vidya
              Lakshmi Portal, offering 137 loan schemes to simplify the
              application process for students seeking educational loans.
            </p>
          </div>
        </div>
      </div>
        <div className="w-full flex justify-center items-center my-6 px-4">
                <div className="w-full max-w-[984px]">
      
           
              <AdBanner displayOrder="3" />
              </div>
               
              </div>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center">
          Types of Education Loans in India
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 text-center max-w-3xl mx-auto">
          Education loans in India cater to different needs based on the level
          of education, study destination, and collateral requirements. Below
          are the major types of education loans:
        </p>

        {/* Responsive Grid Layout */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {loanTypes.map((loan, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="bg-white shadow-md border border-gray-200 rounded-xl p-6 flex flex-col"
            >
              <div className="text-3xl text-blue-500">{loan.icon}</div>
              <h3 className="text-xl font-semibold mt-3">{loan.name}</h3>
              <p className="mt-2 text-gray-600">{loan.description}</p>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center  mb-6">
          Eligibility Criteria for Availing an Education Loan in India
        </h2>
        <p className="text-gray-600 text-center mb-8">
          Education loans in India come with specific eligibility criteria set
          by banks and financial institutions. The following factors determine a
          student's eligibility for the loan:
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300 flex items-start gap-4"
            >
              {criteria.icon}
              <div>
                <h3 className="font-semibold text-lg mb-2">{criteria.title}</h3>
                <ul className="list-disc list-inside text-gray-600 text-md">
                  {criteria.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Key Components of an Education Loan
        </h2>
        <p className="text-center text-gray-600 mb-10">
          Education loans come with several essential components that determine
          the structure and repayment terms of the loan. Here are the key
          components:
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {componentsData1.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-3">
                {item.icon}
                <h3 className="text-lg font-semibold">{item.title}</h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 space-y-1 text-md">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xlfont-bold text-center mb-6">
          🎓 Why Education Loan?
        </h2>
        <p className="text-center text-gray-600 mb-10">
          When financing higher education, students and parents often compare
          Education Loans and Personal Loans. While both provide funding,
          education loans are designed specifically for academic expenses,
          making them a more suitable choice for students.
        </p>

        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border border-gray-200 dark:border-gray-700">
            <thead className="bg-gray-100 dark:bg-gray-800 text-sm text-gray-700 dark:text-gray-200">
              <tr>
                <th className="border px-4 py-2 text-left">Feature</th>
                <th className="border px-4 py-2 text-left">Education Loan</th>
                <th className="border px-4 py-2 text-left">Personal Loan</th>
              </tr>
            </thead>
            <tbody className="text-md text-gray-800 dark:text-gray-300">
              {comparisonData2.map((item, idx) => (
                <tr
                  key={idx}
                  className="odd:bg-white even:bg-gray-50 dark:odd:bg-gray-900 dark:even:bg-gray-800"
                >
                  <td className="border px-4 py-3 font-medium">
                    {item.icon}
                    {item.feature}
                  </td>
                  <td className="border px-4 py-3">{item.educationLoan}</td>
                  <td className="border px-4 py-3">{item.personalLoan}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Pros and Cons of Education Loans
          </h2>
          <p className="text-gray-700 mb-6">✅ Pros:</p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Cons of Education Loans
          </h2>
          <p className="text-gray-700 mb-6">❌ Cons</p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 p-6 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Choosing the Right Education Loan: Key Factors to Consider
          </h3>
          <p className="text-gray-700 mb-6">
            Selecting the right education loan is crucial to ensure manageable
            repayment and financial stability during and after studies. Here are
            the key factors to consider:
          </p>

          {points3.map((item, index) => (
            <div
              key={index}
              className="p-5 mb-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {item.title}
              </h2>
              <ul className="list-disc list-inside text-gray-600 mt-2">
                {item.points.map((point, idx) => (
                  <li key={idx} className="mt-1">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 p-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EducationLoanNew;
